import React, {Component} from 'react';
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { renderField, renderCheckbox, required, renderTextArea, json } from "../../../utils/formValidations.js";
import { withRouter } from "react-router-dom";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter, Collapse, Alert } from "reactstrap";
import Proptypes from "prop-types";
import { NotificationManager } from "react-notifications";
import {getBrandingConfigs } from "../../../actions/actionBranding";
import {getLicenses} from "../../../actions/actionSystemInfo";

class BrandingConfigFormTemplate extends Component {
    constructor (props){
        super(props);
        this.state = {
            currentBranding: {},
            collapseAdvanced: false,
            branding: false,
        };
        this.submitApi = this.submitApi.bind(this);
        this.handleCreateSuccess = this.handleCreateSuccess.bind(this);
        this.handleCreateError = this.handleCreateError.bind(this);
        this.handleUpdateError = this.handleUpdateError.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
    }

    submitApi(userData) {
        if (!userData.categories){
            userData.categories = {};
        }
        if (this.props.fromUpdate) {
            userData.branding_config_id = this.state.currentBranding && this.state.currentBranding.branding_config_id;
            this.props.updateBrandingConfig(userData)
                .then(() => this.handleUpdateSuccess())
                .catch(() => this.handleUpdateError());
        }else {
            this.props.createBrandingConfig(userData)
                .then(() => this.handleCreateSuccess())
                .catch(() => this.handleCreateError());
        }
    }

    handleUpdateSuccess(){
        const {updateBrandingError} = this.props;
        if(updateBrandingError){
            NotificationManager.error(updateBrandingError,"Update Branding Config", 3000);
        }
        else{
            NotificationManager.success("Branding Config Updated", "Successfully Updated Branding Config");
            this.props.history.push("/branding");
        }
    }

    handleUpdateError(){
        const {updateBrandingError} = this.props;
        if(updateBrandingError){
            NotificationManager.error(updateBrandingError,"Update Branding Config", 3000);
        } else
            NotificationManager.error("Update Branding Config Failed", "Update Branding Config", 3000);
    }

    handleCreateSuccess(){
        const {createBrandingError} = this.props;
        if(createBrandingError){
            NotificationManager.error(createBrandingError,"Create Branding Config", 3000);
        }
        else{
            NotificationManager.success("Branding Config Created", "Successfully Created Branding Config");
            this.props.history.push("/branding");
        }
    }

    handleCreateError(){
        const {createBrandingError} = this.props;
        if(createBrandingError){
            NotificationManager.error(createBrandingError,"Create Branding Config", 3000);
        } else
            NotificationManager.error("Create Branding Config Failed","Create Branding Config", 3000);
    }

    cancelButton(){
        this.props.history.push("/branding");
    }


    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.branding_configs && nextProps.branding_configs.length > 0 && this.props.branding_configs !== nextProps.branding_configs && this.props.getBrandingLoading && this.props.fromUpdate){
            let currentBranding = nextProps.branding_configs.find(branding => branding.branding_config_id === this.props.brandingConfigId);
            this.setState({currentBranding: currentBranding});
            this.props.initialize({
                name: currentBranding.name,
                hostname: currentBranding.hostname,
                favicon_logo_url: currentBranding.favicon_logo_url,
                header_logo_url: currentBranding.header_logo_url,
                html_title: currentBranding.html_title,
                login_caption: currentBranding.login_caption,
                login_logo_url: currentBranding.login_logo_url,
                loading_session_text: currentBranding.loading_session_text,
                joining_session_text: currentBranding.joining_session_text,
                destroying_session_text: currentBranding.destroying_session_text,
                is_default: currentBranding.is_default,


            });
        }
    }

    componentDidMount() {
        if (this.props.fromUpdate) {
            this.props.getBrandingConfigs();
        }
        this.props.getLicenses()
            .then(() => {
                const {licenses} = this.props;
                for (let i in licenses) {
                    if (licenses[i].is_verified == true && licenses[i].features && licenses[i].features.branding === true) {
                        this.setState({branding: true})
                    }
                }
            });
    }
    

    render() {
        const {handleSubmit} = this.props;
        const deny_by_default_checked = false;
        if (!this.state.branding){
            return (
                <Alert color="none" isOpen={true}>
                    <h4>Unavailable</h4>
                    This feature must be licensed.
                    <hr />
                    <a href="https://kasmweb.com">More Information</a><br/>
                </Alert>
            )
        }
        return (
            <Form onSubmit={handleSubmit(this.submitApi)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="name" className="requiredasterisk">Name </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="name"
                                       id="name"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="hostname" className="requiredasterisk">Hostname </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="hostname"
                                       id="hostname"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="favicon_logo_url" className="requiredasterisk">Favicon Logo URL </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="favicon_logo_url"
                                       id="favicon_logo_url"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="header_logo_url" className="requiredasterisk">Header Logo URL </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="header_logo_url"
                                       id="header_logo_url"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="html_title" className="requiredasterisk">HTML Title </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="html_title"
                                       id="html_title"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="login_caption" className="requiredasterisk">Login Caption </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="login_caption"
                                       id="login_caption"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="login_logo_url" className="requiredasterisk">Login Logo URL </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="login_logo_url"
                                       id="login_logo_url"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="loading_session_text" className="requiredasterisk">Loading Session Text </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="loading_session_text"
                                       id="loading_session_text"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="joining_session_text" className="requiredasterisk">Joining Session Text </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="joining_session_text"
                                       id="joining_session_text"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="6">
                                <Label htmlFor="destroying_session_text" className="requiredasterisk">Destroying Session Text </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="destroying_session_text"
                                       id="destroying_session_text"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="is_default">Default </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                       name="is_default"
                                       id="is_default"
                                       checked = {deny_by_default_checked}
                                       component={renderCheckbox}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
                        <Button type="cancel" size="sm" color="basic" onClick={() => this.cancelButton()}><i className="fa fa-ban"></i> Cancel</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}

BrandingConfigFormTemplate.proptypes = {
    createBrandingConfig: Proptypes.func,
    updateBrandingConfig: Proptypes.func,
    fromUpdate: Proptypes.bool,
    licenses: Proptypes.array,
};

let BrandingConfigFormWithRouter = withRouter(BrandingConfigFormTemplate);


const selector = formValueSelector('BrandingConfigForm');

let BrandingConfigForm =  connect(state =>{

            const has_categorization_enabled = selector(state, 'enable_categorization');

            return {
                has_categorization_enabled,
                createBrandingError: state.branding.createBrandingError,
                createBrandingLoading: state.branding.createBrandingLoading,
                createdBranding: state.branding.createdBranding,
                updateBrandingError: state.branding.updateBrandingError,
                updateBrandingLoading: state.branding.updateBrandingLoading,
                updatedBranding: state.branding.updatedBranding,
                branding_configs: state.branding.branding_configs,
                getBrandingLoading: state.branding.getBrandingLoading || false,
                licenses: state.system_info.licenses
            }
    },

    dispatch =>
        ({
            getBrandingConfigs: () => dispatch(getBrandingConfigs()),
            getLicenses: () => dispatch(getLicenses()),
        }))(BrandingConfigFormWithRouter);

export default reduxForm({
    form: "BrandingConfigForm",
})(BrandingConfigForm);


// WEBPACK FOOTER //
// ./src/views/Branding/BrandingConfigForm/BrandingConfigForm.js